export const GA_MEASUREMENT_ID =
  (import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined) || "G-66D4QEMYM9";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackGaPageView(pathname: string, search = "") {
  if (typeof window.gtag !== "function") return;
  const pagePath = `${pathname}${search}`;
  window.gtag("config", GA_MEASUREMENT_ID, {
    page_path: pagePath,
    page_title: document.title,
  });
}
